import PropTypes from 'prop-types';
import { Modal, Button } from 'components';
import { Row } from 'antd';
import InfoIcon from 'assets/images/InfoIcon/InfoIcon.svg';
import checkCircleIcon from 'assets/images/CheckCircleIcon/checkCircleIcon.svg';
import cancelCircleFillRed from 'assets/images/CancelCircle/cancelCircleFillRed.svg';

export const ModalIdentificacionSO = ({ open, onClose, updateSO, description }) => {
  const iconMessage = {
    info: InfoIcon,
    correcto: checkCircleIcon,
    error: cancelCircleFillRed
  };

  const handleOK = () => {
    console.log('Sí', description);
    updateSO();
    onClose();
  };
  const handleClose = () => {
    onClose();
  };
  return (
    <Modal
      title=""
      open={open}
      width="28em"
      // width="38em"
      onCancel={handleClose}
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{ style: { display: 'none' } }}>
      <Row style={{ justifyContent: 'center' }}>
        <img style={{ width: 35 }} alt="msj-informativo" src={iconMessage[description]} />
      </Row>
      <Row style={{ justifyContent: 'center', textAlign: 'center', fontSize: '0.9rem' }}>
        {description === 'info' && (
          <>
            <span style={{ fontWeight: 500 }}>
              Los Beneficiados seleccionados se asociarán <br /> al Sujeto Obligado elegido y se
              actualizarán <br /> las Actas de Monitoreos relacionadas,
            </span>
            <Row>
              <span style={{ fontWeight: 500, fontSize: '0.9rem' }}>¿deseas continuar?</span>
            </Row>
          </>
        )}
        {description === 'correcto' && (
          <span style={{ fontSize: '1.1rem', fontWeight: '500', margin: '1.2rem' }}>
            Beneficiado actualizado <br />
            exitosamente
          </span>
        )}
        {description === 'error' && (
          <span style={{ fontSize: '1.1rem', fontWeight: '500', margin: '1.2rem' }}>
            Se produjo un error al actualizar el Beneficiado.
          </span>
        )}
      </Row>
      <Row style={{ justifyContent: 'space-evenly', margin: '15px 0px 0px 5px' }}>
        {description === 'info' && (
          <>
            <Button type="" text="No" onClick={handleClose} />
            <Button type="primary" text="Sí" onClick={handleOK} />
          </>
        )}
      </Row>
    </Modal>
  );
};

ModalIdentificacionSO.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  updateSO: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired
};
